document.addEventListener('DOMContentLoaded', function () {
    const filterContainer = document.querySelector('[data-faq-filters]');
    if (!filterContainer) return;

    const filterButtons = filterContainer.querySelectorAll('.faq-filters__tag');
    const faqSections = document.querySelectorAll('.faq-section');
    const blogGrid = document.querySelector('.blog-grid');
    const noResultsMessage = document.querySelector('.no-results-message');
    const ctnPagination = document.querySelector('.ctn_pagination');
    const searchForm = document.querySelector('.blog-hero__search-form');
    const isBlogPage = searchForm && searchForm.getAttribute('data-blog-page') === 'true';
    
    let isFiltering = false;
    let originalGridHTML = '';
    let originalPaginationHTML = '';

    function setActiveFilter(activeButton) {
        // Remove active class from all buttons
        filterButtons.forEach(btn => {
            btn.classList.remove('faq-filters__tag--active');
            btn.setAttribute('aria-selected', 'false');
        });

        // Add active class to clicked button
        activeButton.classList.add('faq-filters__tag--active');
        activeButton.setAttribute('aria-selected', 'true');
    }

    // Save current grid and pagination HTML before filtering
    function saveOriginalContent() {
        // Always save current state before filtering
        if (blogGrid) {
            originalGridHTML = blogGrid.innerHTML;
        }
        
        if (ctnPagination) {
            const paginationElement = ctnPagination.querySelector('[data-pagination-ajax]');
            if (paginationElement) {
                originalPaginationHTML = paginationElement.outerHTML;
            }
        }
    }
    
    // Reinitialize AJAX pagination
    function reinitAjaxPagination() {
        // Trigger re-initialization of pagination in blog-navigation.js
        const paginationContainer = document.querySelector('[data-pagination-ajax]');
        if (paginationContainer) {
            // Dispatch custom event to notify blog-navigation.js
            const event = new CustomEvent('paginationRestored');
            document.dispatchEvent(event);
        }
    }
    
    // Restore original content
    function restoreOriginalContent() {
        if (!blogGrid || !ctnPagination) return;
        
        // Restore grid
        if (originalGridHTML) {
            blogGrid.innerHTML = originalGridHTML;
        }
        
        // Restore pagination
        const paginationElement = ctnPagination.querySelector('[data-pagination-ajax]');
        if (paginationElement && originalPaginationHTML) {
            paginationElement.outerHTML = originalPaginationHTML;
            // Reinitialize AJAX pagination after restoring
            reinitAjaxPagination();
        } else if (paginationElement) {
            paginationElement.style.display = '';
        }
        
        // Hide no results message
        if (noResultsMessage) {
            noResultsMessage.style.display = 'none';
        }
    }
    
    // Filter by tag using Predictive Search API
    async function filterByTagAPI(tagId) {
        if (isFiltering || !isBlogPage) return;
        
        isFiltering = true;
        
        // Always save current content before filtering
        saveOriginalContent();
        
        try {
            // Show loading state
            if (blogGrid) {
                blogGrid.style.opacity = '0.5';
            }
            
            // Call Predictive Search API
            const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(tagId)}&resources[type]=article&resources[limit]=50&resources[options][fields]=tag`);
            
            if (!response.ok) throw new Error('Filter request failed');
            
            const data = await response.json();
            const articles = data.resources.results.articles || [];
            
            // Filter articles that have the exact tag
            const filteredArticles = articles.filter(article => {
                return article.tags && article.tags.some(tag => 
                    tag.toLowerCase() === tagId.toLowerCase()
                );
            });
            
            // Display filtered results
            displayFilteredArticles(filteredArticles, tagId);
            
        } catch (error) {
            console.error('Filter by tag error:', error);
            showFilterError();
        } finally {
            isFiltering = false;
            if (blogGrid) {
                blogGrid.style.opacity = '1';
            }
        }
    }
    
    // Display filtered articles
    function displayFilteredArticles(articles, tagId) {
        if (!blogGrid) return;
        
        // Hide pagination during filter
        const paginationElement = ctnPagination.querySelector('[data-pagination-ajax]');
        if (paginationElement) {
            paginationElement.style.display = 'none';
        }
        
        // Clear current grid
        blogGrid.innerHTML = '';
        
        if (articles.length === 0) {
            // Show no results message
            if (noResultsMessage) {
                const messageText = noResultsMessage.querySelector('.no-results-text');
                if (messageText) {
                    messageText.textContent = `No articles found for category "${tagId}". Try a different filter.`;
                }
                noResultsMessage.style.display = 'block';
            }
            return;
        }
        
        // Hide no results message
        if (noResultsMessage) {
            noResultsMessage.style.display = 'none';
        }
        
        // Get blog handle from grid data attribute
        const blogHandle = blogGrid.getAttribute('data-blog-handle');
        
        // Filter articles by blog handle if available
        const filteredArticles = blogHandle 
            ? articles.filter(article => article.url.includes(`/blogs/${blogHandle}/`))
            : articles;
        
        // Render articles
        filteredArticles.forEach(article => {
            const articleCard = createArticleCard(article);
            blogGrid.appendChild(articleCard);
        });
    }
    
    // Create article card HTML
    function createArticleCard(article) {
        const card = document.createElement('div');
        card.className = 'blog-card';
        card.setAttribute('data-filters-id', article.tags && article.tags.length > 0 ? article.tags[0] : '');
        card.setAttribute('data-article-id', article.id);
        
        const publishedDate = new Date(article.published_at);
        const formattedDate = publishedDate.toLocaleDateString('en-US', { 
            year: 'numeric', 
            month: 'short', 
            day: 'numeric' 
        });
        
        card.innerHTML = `
            <div>
                <div class="ctn_img">
                    <a href="${article.url}">
                        ${article.image ? `<img src="${article.image}" alt="${article.title}" loading="lazy" class="parallax-image">` : ''}
                    </a>
                </div>
                <div class="ctn_info">
                    <div class="ctn_date">
                        ${article.tags && article.tags.length > 0 ? `
                            <p class="category" data="${article.tags[0]}">
                                ${article.tags[0].substring(0, 33)}
                            </p>
                        ` : '<p class="category">No Category</p>'}
                        <span>|</span>
                        <p class="date">
                            <time datetime="${article.published_at}">${formattedDate}</time>
                        </p>
                    </div>
                    <a class="title" href="${article.url}">
                        ${article.title}
                    </a>
                </div>
            </div>
        `;
        
        return card;
    }
    
    // Show filter error
    function showFilterError() {
        if (noResultsMessage) {
            const messageText = noResultsMessage.querySelector('.no-results-text');
            if (messageText) {
                messageText.textContent = 'An error occurred while filtering. Please try again.';
            }
            noResultsMessage.style.display = 'block';
        }
    }
    
    function filterFAQSections(filterId) {
        // For blog pages, use API filtering
        if (isBlogPage) {
            if (filterId === 'all') {
                restoreOriginalContent();
            } else {
                filterByTagAPI(filterId);
            }
            return;
        }
        
        // For FAQ pages, use client-side filtering
        const searchInput = document.querySelector('.faq-hero__search-input');
        const hasActiveSearch = searchInput && searchInput.value.trim() !== '';
        
        if (hasActiveSearch) {
            setTimeout(() => {
                if (searchInput.value.trim() !== '') {
                    const searchEvent = new Event('input');
                    searchInput.dispatchEvent(searchEvent);
                }
            }, 50);
            return;
        }
        
        faqSections.forEach(section => {
            const sectionCategoryId = section.dataset.faqCategory;
            const matchesCategory = filterId === 'all' || sectionCategoryId === filterId;
            
            if (matchesCategory) {
                section.style.display = '';
                section.setAttribute('aria-hidden', 'false');
                
                const sectionTitle = section.querySelector('.faq-section__title');
                if (sectionTitle) {
                    sectionTitle.style.display = '';
                }
            } else {
                section.style.display = 'none';
                section.setAttribute('aria-hidden', 'true');
                
                const sectionTitle = section.querySelector('.faq-section__title');
                if (sectionTitle) {
                    sectionTitle.style.display = 'none';
                }
            }
        });
        
        const faqItems = document.querySelectorAll('.faq-item');
        faqItems.forEach(item => {
            const itemSection = item.closest('.faq-section');
            const itemCategoryId = itemSection ? itemSection.dataset.faqCategory : '';
            const matchesCategory = filterId === 'all' || itemCategoryId === filterId;
            
            item.style.display = matchesCategory ? '' : 'none';
        });
    }

    // Add click event listeners to filter buttons
    filterButtons.forEach(button => {
        button.addEventListener('click', function () {
            const filterId = this.dataset.filterId;
            setActiveFilter(this);
            filterFAQSections(filterId);
            
            // Emit custom event for other components (like blog cards) only if blog navigation exists
            const blogNavigationSection = document.querySelector('.blog_navigation');
            if (blogNavigationSection) {
                const filterEvent = new CustomEvent('filterChanged', {
                    detail: { filterId: filterId }
                });
                document.dispatchEvent(filterEvent);
            }
        });
    });

    // Listen for search input changes to detect when search is cleared
    const searchInput = document.querySelector('.faq-hero__search-input');
    if (searchInput) {
        // Monitor search input for changes
        let lastSearchValue = '';
        const checkSearchState = () => {
            const currentValue = searchInput.value.trim();
            // If search was cleared (had value, now empty), reapply current filter
            if (lastSearchValue !== '' && currentValue === '') {
                const activeFilter = document.querySelector('.faq-filters__tag--active');
                if (activeFilter) {
                    const filterId = activeFilter.dataset.filterId;
                    setTimeout(() => filterFAQSections(filterId), 100);
                }
            }
            lastSearchValue = currentValue;
        };
        
        // Check on input events
        searchInput.addEventListener('input', checkSearchState);
        searchInput.addEventListener('keyup', checkSearchState);
        
        // Also check when search button is clicked (in case it clears)
        const searchButton = document.querySelector('.faq-hero__search-button');
        if (searchButton) {
            searchButton.addEventListener('click', () => {
                setTimeout(checkSearchState, 100);
            });
        }
    }

    // Initialize with first filter active (All FAQ)
    if (filterButtons.length > 0) {
        const firstFilter = filterButtons[0];
        const initialFilterId = firstFilter.dataset.filterId;
        if (!isBlogPage) {
            filterFAQSections(initialFilterId);
        }
        // Note: For blog pages, we DON'T save content on initial load
        // Content is saved only when user clicks a filter for the first time
    }
});